<app-alert></app-alert>

<div class="report-toolbar">
  <div class="form-field">
    <label>Saved Reports</label>
    <select
      [ngModel]="selectedSavedReportId == null ? '' : '' + selectedSavedReportId"
      (ngModelChange)="onSavedReportChange($event)">
      <option value="">-- Select --</option>
      <option *ngFor="let r of savedReports" [value]="r.Id">
        {{ r.Name }}
      </option>
    </select>
  </div>

  <div class="form-field">
    <label>Report Name</label>
    <input type="text" [(ngModel)]="reportName" placeholder="e.g. Sales-Pune-2026" />
  </div>

  <div class="button-field">
    <button type="button" class="icon-btn icon-btn--save" title="Save" (click)="saveReport()"
      [disabled]="!selectedReportId">
      <i class="bi bi-save"></i>
    </button>
    <button type="button" class="icon-btn icon-btn--update" title="Update" (click)="requestUpdateReport()"
      [disabled]="!selectedSavedReportId">
      <i class="bi bi-pencil-square"></i>
    </button>
    <button type="button" class="reset-btn" (click)="resetReport()">
      Reset
    </button>
  </div>

  <div class="button-field">
    <button type="button" class="reset-btn" (click)="openCalcDialog()"
      [disabled]="!selectedReportId">
      Add Column
    </button>
  </div>

  <div class="toolbar-export">
    <button class="export-btn" type="button" (click)="exportToExcel()" [disabled]="isExporting || !selectedReportId">
      {{ isExporting ? 'Exporting...' : 'Export to Excel' }}  
    </button>
  </div>

  <div class="header-user-section">
    <div class="user-profile" #userProfile>
      <button type="button" class="user-profile__trigger" (click)="toggleProfileMenu($event)">
        <span class="user-profile__avatar">
          <i class="bi bi-person-fill"></i>
        </span>
        <span class="user-profile__email">
          {{ displayUserName }}
        </span>
        <i class="bi bi-chevron-down user-profile__chevron" [class.user-profile__chevron--open]="menuOpen">
        </i>
      </button>

      <div *ngIf="menuOpen" class="user-profile__dropdown">
        <div class="user-profile__dropdown-top">
          <div class="user-profile__brand">
            <div class="user-profile__brand-line1">
              <span class="user-profile__im">IM</span>
              <span class="user-profile__pact">Pact</span>
            </div>
            <div class="user-profile__brand-line2">
              Exchange
            </div>
          </div>
          <button class="user-profile__logout" (click)="logout()">
            Log Out
          </button>
        </div>
        <div class="user-profile__divider"></div>
        <div class="user-profile__footer">
          Analysis Report
        </div>
      </div>
    </div>
  </div>
</div>

<div class="confirm-overlay" *ngIf="showUpdateConfirm" (click)="cancelUpdateConfirm()">
  <div class="confirm-dialog" (click)="$event.stopPropagation()">
    <p class="confirm-dialog__message">
      Update saved report "{{ reportName }}" with the current grid layout?
    </p>
    <div class="confirm-dialog__actions">
      <button type="button" class="confirm-dialog__btn confirm-dialog__btn--no" (click)="cancelUpdateConfirm()">
        No
      </button>
      <button type="button" class="confirm-dialog__btn confirm-dialog__btn--yes" (click)="confirmUpdateReport()"
        [disabled]="isUpdating">
        {{ isUpdating ? 'Updating...' : 'Yes' }}
      </button>
    </div>
  </div>
</div>

<div class="confirm-overlay" *ngIf="showCalcDialog" (click)="closeCalcDialog()">
  <div class="confirm-dialog calc-dialog" (click)="$event.stopPropagation()">
    <p class="confirm-dialog__message">{{ editingCalcName ? 'Edit Calculated Column' : 'Add Calculated Column' }}</p>
    <label class="calc-dialog__label">Column name</label>
    <input type="text" [(ngModel)]="calcName" placeholder="AvgTicketSold" />
    <label class="calc-dialog__label">Formula</label>
    <input type="text" [(ngModel)]="calcFormula" placeholder="GrossCollection / NoOfTicketsSold" />
    <div class="calc-chips">
      <button type="button" class="calc-chip" *ngFor="let f of calcSourceFields" (click)="insertCalcField(f)">
        {{ f }}
      </button>
    </div>
    <p class="calc-dialog__error" *ngIf="calcError">{{ calcError }}</p>
    <div class="confirm-dialog__actions">
      <button type="button" class="confirm-dialog__btn confirm-dialog__btn--no" (click)="closeCalcDialog()">
        Cancel
      </button>
      <button type="button" class="confirm-dialog__btn confirm-dialog__btn--yes" (click)="submitCalcDialog()">
        {{ editingCalcName ? 'Save' : 'Create' }}
      </button>
    </div>
  </div>
</div>

<div class="app-loading-overlay" *ngIf="isAppLoading">
  <div class="app-loading-overlay__panel">
    <div class="app-loading-overlay__spinner" aria-hidden="true"></div>
    <p class="app-loading-overlay__text">Loading…</p>
  </div>
</div>

<ag-grid-angular class="ag-theme-alpine-dark custom-dark-grid" style="width:100%; height:700px"
  [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" rowModelType="serverSide"
  (gridReady)="onGridReady($event)">
</ag-grid-angular>
